// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"48621aee","513":"6d0d3a9b","703":"d3d919a7","787":"577b5d7f","896":"ef37154b"}[chunkId] + ".chunk.js";
};